/**
 * tab页错误信息
 */
export class TabError {
  /**
	 * @param {String} message 消息
	 * @param {String} tabName tab页名称
	 */
  constructor(message, tabName) {
    this.message = message
    this.tabName = tabName
  }
}
